module.exports = __webpack_public_path__ + "static/media/LWSS.661f815c.gif";